/* import __COLOCATED_TEMPLATE__ from './client-provider-section.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './client-provider-section.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsGoodFaithEstimateClientProviderSection extends Component {}
